import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconLink: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 10.6257H7.5C7.155 10.6257 6.875 10.3457 6.875 10.0007C6.875 9.65565 7.155 9.37565 7.5 9.37565H12.5C12.845 9.37565 13.125 9.65565 13.125 10.0007C13.125 10.3457 12.845 10.6257 12.5 10.6257ZM18.125 10.0007C18.125 7.35815 15.9758 5.20898 13.3333 5.20898H11.6667C11.3217 5.20898 11.0417 5.48898 11.0417 5.83398C11.0417 6.17898 11.3217 6.45898 11.6667 6.45898H13.3333C15.2867 6.45898 16.875 8.04732 16.875 10.0007C16.875 11.954 15.2867 13.5423 13.3333 13.5423H11.6667C11.3217 13.5423 11.0417 13.8223 11.0417 14.1673C11.0417 14.5123 11.3217 14.7923 11.6667 14.7923H13.3333C15.9758 14.7923 18.125 12.6432 18.125 10.0007ZM8.95833 14.1673C8.95833 13.8223 8.67833 13.5423 8.33333 13.5423H6.66667C4.71333 13.5423 3.125 11.954 3.125 10.0007C3.125 8.04732 4.71333 6.45898 6.66667 6.45898H8.33333C8.67833 6.45898 8.95833 6.17898 8.95833 5.83398C8.95833 5.48898 8.67833 5.20898 8.33333 5.20898H6.66667C4.02417 5.20898 1.875 7.35815 1.875 10.0007C1.875 12.6432 4.02417 14.7923 6.66667 14.7923H8.33333C8.67833 14.7923 8.95833 14.5123 8.95833 14.1673Z"
      fill={color}
    />
  </svg>
);

export default IconLink;
